module.exports = __webpack_public_path__ + "6dadc2a4ae2355f730beaa6a78f797c0.svg";